module.exports = __webpack_public_path__ + "static/img/PrinterReady.8f29ed2.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/device-ui/PrinterReady.gif
// module id = 23Ja
// module chunks = 1